var UserDataKeyMap = [{
  toKey: 'userName',
  fromKey: 'username' //用户名

}, {
  toKey: 'userEmail',
  fromKey: 'email' //用户Email，已经做过展示加密处理

}, {
  toKey: 'userNickname',
  fromKey: 'nickname' //用户的昵称

}, {
  toKey: 'userIsValid',
  fromKey: 'status' //UserData是否有效 (0无效，1有效)

}, {
  toKey: 'userPhone',
  fromKey: 'mobile' //用户手机号

}];
export { UserDataKeyMap };